import { CustomAttributeType } from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import {
  CHECKBOX_FIELD_CONFIG,
  DATE_FIELD_CONFIG,
  DATE_TIME_FIELD_CONFIG,
  DROPDOWN_FIELD_CONFIG,
  LOOKUP_FIELD_CONFIG,
  MULTI_LINE_TEXT_FIELD_CONFIG,
  MULTI_SELECT_FIELD_CONFIG,
  NUMBER_FIELD_CONFIG,
  SHORT_TEXT_FIELD_CONFIG,
  URL_FIELD_CONFIG,
} from './components';

import { CustomAttributeFieldConfig } from './types';

export const FIELD_REGISTRY: Record<CustomAttributeType, CustomAttributeFieldConfig> = {
  short_text: SHORT_TEXT_FIELD_CONFIG,
  multi_line_text: MULTI_LINE_TEXT_FIELD_CONFIG,
  number: NUMBER_FIELD_CONFIG,
  checkbox: CHECKBOX_FIELD_CONFIG,
  dropdown: DROPDOWN_FIELD_CONFIG,
  multi_select: MULTI_SELECT_FIELD_CONFIG,
  date: DATE_FIELD_CONFIG,
  date_time: DATE_TIME_FIELD_CONFIG,
  url: URL_FIELD_CONFIG,
  lookup_relational: LOOKUP_FIELD_CONFIG,
};

export function getCustomAttributeConfig(
  type: CustomAttributeType,
): CustomAttributeFieldConfig {
  return FIELD_REGISTRY[type];
}
